<template>
  <div>
    <div class="content">
      <div class="title">
        <span>支付信息</span>
      </div>
      <ul>
        <li
          v-if="
            orderInfo.subjectName != '宝丰县人民医院' &&
            orderInfo.subjectName != '青县人民医院'
          "
        >
          <span>医院：</span>
          <span>{{ orderInfo.subjectName }}</span>
        </li>
        <li>
          <p>
            <span>处方号：</span>
            <span>{{ orderInfo.medicalAdviceCode }}</span>
          </p>
        </li>
        <li
          v-if="
            orderInfo.subjectName != '赵县妇幼保健院' &&
            orderInfo.subjectName != '青县人民医院'
          "
        >
          <div>
            <p>
              <span>科室：</span>
              <span>{{ orderInfo.creatorDeptName }}</span>
            </p>
            <p>
              <span>医师：</span>
              <span>{{ orderInfo.operateUser }}</span>
            </p>
          </div>
        </li>
        <li>
          <div>
            <p>
              <span>姓名：</span>
              <span>{{ orderInfo.patientName }}</span>
            </p>
            <p>
              <span>类型：</span>
              <!-- <span v-if="orderInfo.adviceType === 4">预交费</span> -->
              <span>营养医嘱</span>
              <!-- <span v-if="orderInfo.adviceType === 6">宣教医嘱</span> -->
            </p>
          </div>
        </li>
        <li>
          <span>开具日期：</span>
          <span>{{ orderInfo.createTime }}</span>
        </li>
      </ul>
      <div>
        <div class="totalContent">
          <p class="title">处方支付金额</p>
          <p>
            <span style="color: var(--basic-green)">金额：</span>
            <span>￥{{ orderInfo.totalAmount || 0 }}</span>
            <span
              v-if="orderInfo.orderStatus === 1"
              style="color: var(--basic-red)"
            >
              未缴费
            </span>
            <span
              v-if="orderInfo.orderStatus === 2"
              style="color: var(--basic-red)"
            >
              支付中
            </span>
            <span
              v-if="orderInfo.orderStatus === 3"
              style="color: var(--basic-green)"
            >
              已支付
            </span>
            <span v-if="orderInfo.orderStatus === 4">退款中</span>
            <span v-if="orderInfo.orderStatus === 5">已退款</span>
            <span v-if="orderInfo.orderStatus === 6">已作废，请重新开具</span>
          </p>
        </div>
        <div
          v-if="
            orderInfo.subjectName == '长治医学院附属和平医院' &&
            orderInfo.prescriptionType == 2
          "
          style="margin-top: 10px"
        >
          <img src="@/assets/img/heping.jpg" alt="" />
        </div>
        <div class="btnContent">
          <van-button
            v-if="orderInfo.orderStatus === 1"
            @click="payment"
            round
            size="small"
            type="success"
          >
            立即支付
          </van-button>
          <!--          <van-button-->
          <!--            v-if="orderInfo.orderStatus === 3"-->
          <!--            @click="openInvoice"-->
          <!--            round-->
          <!--            size="small"-->
          <!--            style="margin-bottom: 0"-->
          <!--            type="success"-->
          <!--            >发票开具-->
          <!--          </van-button>-->
          <!-- <van-button
            @click="openUsage"
            round
            size="small"
            type="success"
            >查看用法用量</van-button
          > -->

          <van-button
            v-if="
              orderInfo.orderStatus === 3 &&
              (orderInfo.subjectName === '铭方健康管理平台' ||
                orderInfo.subjectName === '太和县人民医院' ||
                orderInfo.subjectName === '暨南大学附属第一医院')
            "
            @click="openInvoice"
            round
            size="small"
            type="success"
          >
            发票开具
          </van-button>
          <!-- <el-button v-if="orderInfo.invoiceType === 1"> 已开具发票 </el-button> -->
        </div>
      </div>
      <!-- <div class="seeInfoContent">
        <van-button @click="seeInfo" round size="small" type="success"
          >查看处方详情
        </van-button>
        <div
          style="
            width: 50%;
            height: 30px;
            background: #07c160;
            text-align: center;
            margin: 0 auto;
            border-radius: 15px;
            color: #ffffff;
          "
          ref="openbtn"
        >
          <wx-open-launch-weapp
            id="launch-btn"
            username="gh_bc775a012b94"
            path="/pages/index/index.html?code=4"
          >
            <template style="width: 100%">
              <button style="color: #ffffff">打开小程序</button>
            </template>
            <script type="text/wxtag-template" id="tmplate">
              <button>打开小程序</button>
            </script>
          </wx-open-launch-weapp>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import {
  requestInvoicePrescription,
  requestGetJsticket,
  wechatUserBind,
} from "@/api/prescription/prescription";
import { reactive, toRefs, onMounted } from "vue";
// import { requestWechatCode } from "@/api/wechat/wechatAuto";
import moment from "moment";
import { useRoute, useRouter } from "vue-router";
import axios from "axios";
export default {
  methods: {
    //跳转小程序
    wx_createRescue() {
      let width = this.$refs.openbtn.clientWidth;
      let height = this.$refs.openbtn.clientHeight;
      var buttonStyle = `width:${width}px;height:${height}px;display:block;color:#fff;font-size:12px;font-weight:bold;line-height:30px;background:#07c160;border-radius:15px;border:none;text-align:center`;
      console.log(this.orderInfo.medicalAdviceCode);
      var page = `pages/patientBind/patientBind?patientCode=${this.orderInfo.medicalAdviceCode}`;
      // var href=window.location.href.split('#')[0];
      this.$refs.openbtn.innerHTML = `<wx-open-launch-weapp id="launch-btn" username="gh_bc775a012b94" path="${page}"><template><botton style="${buttonStyle}">跳转小程序</botton></template></wx-open-launch-weapp>`;
    },
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      orderInfo: "",
      medicalAdviceCode: route.query.adviceCode,
      category: route.query.category,
    });

    // 获取支付信息接口
    requestInvoicePrescription({
      adviceCode: state.medicalAdviceCode,
      category: state.category,
      authCode: route.query.code,
    }).then((v) => {
      const { data } = v;
      state.orderInfo = data;
      state.paymentAddress = data.paymentUrl;
      state.orderInfo.createTime = moment(state.orderInfo.createTime).format(
        "YYYY-MM-DD HH:mm:ss",
      );
      state.orderInfo.totalAmount = state.orderInfo.totalAmount.toFixed(2);
      // if (route.query.code && data.subjectName === '山西省人民医院') {
      //   // 复购
      //   axios({
      //     method: 'post',
      //     url: '/api/open/wechat/user-bind',
      //     responseType: 'json',
      //     data: {
      //       code: route.query.code,
      //       patientId: data.patientId,
      //       patientName: data.patientName,
      //       subjectName: data.subjectName,
      //       subjectCode: data.subjectCode,
      //     },
      //   })
      // }
    });

    // 查看更多处方信息
    const seeInfo = () => {
      window.location.href =
        "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg2NDUyNjA4Mw==&scene=110#wechat_redirect";
    };
    // 支付方法
    const payment = () => {
      window.location.href = state.paymentAddress;
    };

    const openUsage = () => {
      router.push({
        path: "/prescription/usage",
        query: { id: state.orderInfo.medicalAdviceId },
      });
    };

    // 开具发票
    const openInvoice = () => {
      localStorage.setItem(
        "changeAdviceCode",
        state.orderInfo.medicalAdviceCode,
      );
      router.push({ path: "invoice" });
      // window.location.replace(requestWechatCode());
    };

    onMounted(() => {
      // const code = route.query.code
      // const redirectUri = encodeURIComponent(location.href.split('#')[0])
      // // const redirectUri = window.location.href.replace(
      // //   window.location.origin,
      // //   '',
      // // )
      // const appId = 'wx6cfd6f1d50ea07ba'
      // if (!code && state.orderInfo.subjectName === '山西省人民医院') {
      //   // 拼接微信官方授权链接，自动跳转
      //   // const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(
      //   //   `https://wx.sxmfyy.com/auth/tiangang.sxmfyy.com${redirectUri}`,
      //   // )}&response_type=code&scope=snsapi_base&state=TEST123#wechat_redirect`
      //   const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
      //   window.location.href = authUrl
      // }
    });
    return {
      ...toRefs(state),
      payment,
      requestInvoicePrescription,
      requestGetJsticket,
      openInvoice,
      openUsage,
      seeInfo,
    };
  },
};
</script>
<style lang="scss" scoped>
.content {
  border: 1px solid var(--basic-border-color);
  border-top: none;

  .totalContent {
    .title {
      opacity: 0.5;
    }

    p:last-of-type {
      background: var(--basic-price);
      padding: 16px;
      // background: ;
      text-align: left;

      span {
        font-size: 17px;
        display: inline-block;
        width: 32%;
      }
    }
  }

  .title {
    height: 40px;
    padding-left: 10px;
    line-height: 40px;
    border-bottom: 1px solid var(--basic-border-color);

    span {
      padding: 2px 10px;
      border-radius: 10px;
      color: #fff;
      font-size: 12px;
      background: var(--basic-green);
    }
  }

  ul {
    li {
      padding: 16px;
      border-bottom: 1px solid var(--basic-border-color);

      span:first-of-type {
        color: var(--basic-labe);
      }

      div {
        p {
          display: inline-block;
          width: 48%;
        }

        p:last-of-type {
          border: none;
          padding-left: 10px;
        }
      }
    }
  }
}

.btnContent {
  padding: 20px 20px 0 20px;
  text-align: center;

  button {
    width: 50%;
    display: block;
    margin: 0 auto;
    margin-bottom: 10px;
  }
}

.seeInfoContent {
  padding: 10px 20px 20px 20px;
  text-align: center;

  button {
    width: 50%;
    display: block;
    margin: 0 auto;
    margin-bottom: 10px;
  }
}
</style>
